// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__W5bMm","avatar":"UserMenu_avatar__WqlHZ","name":"UserMenu_name__YdBP0","button":"UserMenu_button__+Syjz"};